import React, { useCallback } from 'react'
import $t from '../../../i18n'
import { useDispatch } from 'react-redux'
import Actions from '../../../actions'
import { Button } from 'antd'

import './ThankYou.css'
import { routes } from '../../../consts'

const ThankYou = () => {
  const dispatch = useDispatch()

  const redirectToChat = useCallback(() => {
    dispatch(Actions.createAction(Actions.NAVIGATED_TO, routes.ROOT))
  })

  return (
    <div className="thank-you-screen">
      <div className="thank-you-title">
        <div className="subtitle">{$t('pages.thankYou.subtitle')}</div>
        <div className="main-title">{$t('pages.thankYou.title')}</div>
      </div>
      <Button onClick={redirectToChat} type="primary">
        {$t('common.startOver')}
      </Button>
    </div>
  )
}

export default ThankYou
